import { Button } from "antd";
import { IconoCheck, IconoAlerta, IconoInfo, IconoFlechaDerecha } from "./AuditIconos";

// AUDITORIA-CLINICA-REDISENO (FASE 1 · bloque D) -- barra de acción fija.
//
// Regla del rediseño: NUNCA un botón deshabilitado sin explicación. Si
// "Marcar como auditada" no se puede pulsar, la izquierda dice exactamente por
// qué. Los motivos son los REALES del sistema (cita no finalizada, revisión ya
// cerrada, corrección a medio guardar); el "faltan N puntos de verificación"
// de la maqueta no aplica porque no hay checklist que persistir (FASE 0 §6).
//
// Sin permiso `auditoria.clinica.correct` las acciones de escritura no se
// renderizan -- patrón ya usado en el repo (PlanListado.js), nunca
// disabled+tooltip.

function AtencionBarraAcciones({
    puedeCorregir,
    bloqueo,
    nota,
    ejecutando,
    mostrarGuardar,
    mostrarCerrar,
    onGuardarContinuar,
    onMarcarAuditada,
    onSiguiente,
    haySiguiente,
}) {
    return (
        <div className="ac-accionbar" data-testid="ac-accionbar">
            <div className="ac-accionbar__motivo" data-testid="ac-accionbar-motivo">
                {bloqueo ? (
                    <>
                        <IconoAlerta />
                        <span>{bloqueo}</span>
                    </>
                ) : (
                    <>
                        <IconoInfo />
                        <span>{nota}</span>
                    </>
                )}
            </div>
            <div className="ac-accionbar__acciones">
                {puedeCorregir && mostrarGuardar && (
                    <Button onClick={onGuardarContinuar} loading={ejecutando} data-testid="ac-btn-continuar-despues">
                        Guardar y continuar después
                    </Button>
                )}
                {puedeCorregir && mostrarCerrar && (
                    <Button
                        type="primary"
                        icon={<IconoCheck />}
                        onClick={onMarcarAuditada}
                        loading={ejecutando}
                        disabled={!!bloqueo}
                        data-testid="ac-btn-auditada"
                    >
                        Marcar como auditada
                    </Button>
                )}
                {haySiguiente && (
                    <Button onClick={onSiguiente} data-testid="ac-btn-siguiente">
                        Siguiente atención <IconoFlechaDerecha size={14} />
                    </Button>
                )}
            </div>
        </div>
    );
}

export default AtencionBarraAcciones;
